import { isArrayLength } from './genericHelpers';

export const extractFromResponse = (response, level1, level2) => {
  return response?.features?.[0]?.properties?.context?.[level1]?.[level2] || null;
};

export const filterSubscriptionPricesByType = (subscriptionPrices, type) => {
  return (
    (isArrayLength(subscriptionPrices) &&
      subscriptionPrices.filter(price => {
        return price?.product?.metadata?.userType === type;
      })) ||
    []
  );
};

export const getListingBannerImage = listing => {
  return listing?.attributes?.publicData?.bannerImage;
};

export const getReferredUsers = user => {
  if (!user?.id) return null;
  return user?.attributes?.profile?.privateData?.referredUsers || [];
};
export const getReferralPoints = user => {
  if (!user?.id) return null;
  return user?.attributes?.profile?.privateData?.referralPoints || 0;
};
export const getReferrerId = user => {
  if (!user?.id) return null;
  return user?.attributes?.profile?.privateData?.referrerId || null;
};
export const getMessageAttachments = tx => {
  if (!tx?.id) return null;
  return tx?.attributes?.metadata?.attachments || [];
};

// Safely extract a human-readable filename from a URL
export const extractFileNameFromUrl = url => {
  if (!url) return null;
  try {
    const u = new URL(url);
    const qp = u.searchParams;
    const fromQuery =
      qp.get('filename') ||
      qp.get('file') ||
      qp.get('name') ||
      qp.get('dl') ||
      (qp.get('response-content-disposition') || '')
        .replace(/^attachment;\s*/i, '')
        .replace(/^inline;\s*/i, '')
        .replace(/^filename\*=UTF-8''/i, '')
        .replace(/^filename=/i, '') ||
      null;

    if (fromQuery) return decodeURIComponent(fromQuery);

    const pathname = u.pathname || '';
    const segments = pathname.split('/').filter(Boolean);
    const last = segments.pop();
    return last ? decodeURIComponent(last) : null;
  } catch (_) {
    const clean = String(url)
      .split('?')[0]
      .split('#')[0];
    const last = clean.split('/').pop();
    return last ? decodeURIComponent(last) : null;
  }
};

export const extractAllPhotosFromUnlockableContent = (unlockableContent = {}) => {
  const photos = [];

  // 1. From photos[] array
  (unlockableContent.photos || []).forEach((item, index) => {
    (item.files || []).forEach(file => {
      if (file.fileLink) {
        // Only include if url exists
        photos.push({
          id: `photo-${file.key}`, // unique ID
          url: file.fileLink,
          name: file.name || `Photo ${index + 1}`,
          originalItemIndex: index,
          type: 'unlockable-photo',
        });
      }
    });
  });

  // 2. From posts[].photo array
  (unlockableContent.posts || []).forEach((post, postIndex) => {
    (post.photo || []).forEach(file => {
      if (file.fileLink) {
        // Only include if url exists
        photos.push({
          id: `post-photo-${file.key}`,
          url: file.fileLink,
          name: file.name || `Post Photo ${postIndex + 1}`,
          originalPostTitle: post.title,
          type: 'post-photo',
        });
      }
    });
  });

  return photos;
};

export const getServiceOfferParams = transaction => {
  const protectedData = transaction?.attributes?.protectedData || {};
  let parsed = {};
  try {
    parsed = JSON.parse(protectedData?.serviceOfferParams || '{}');
  } catch {}
  return parsed;
};
